module.exports = __webpack_public_path__ + "static/media/bg1.e6d7b616.jpg";